import script from "./RightsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RightsPage.vue?vue&type=script&setup=true&lang=js"

import "./RightsPage.vue?vue&type=style&index=0&id=17756fcd&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17756fcd"]])

export default __exports__